import { BaseDTO } from './basedto';
import { IProposalReasonTestDoc } from './interfaces/IProposalReasonTestDoc.interface';

export class ProposalReasonTestDoc extends BaseDTO
    implements IProposalReasonTestDoc {
    ProposalId: number;
    ReasonsNonSubTestDocId: number;
    ReasonTestDocDescription: string;
    NonSubTestDocReason: string;
    constructor() {
        super();
    }
}
